module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFpJREFUeNpi5GlwYCAFMDGQCGivgQWZE23gEa3vDmR4LSwEktvi+4Hk0os7l17YgV2DvICErYIBnAthH3l4cZB7ms7B+vDDi8MPLsC5EDZQEFkN4zBISwABBgCAqxjsvnIXywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pause2.png
// module id = 619
// module chunks = 1 6